module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./shared */ "./src/shared/index.tsx"), exports);


/***/ }),

/***/ "./src/shared/index.css":
/*!******************************!*\
  !*** ./src/shared/index.css ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tooltip_component-wrapper-0294cec31b","container":"tooltip_component-container-54a153a99b","block":"tooltip_component-block-ed8a6b0ee9","thin":"tooltip_component-thin-ccb71d6123","wide":"tooltip_component-wide-9c5ddebb22","arrow":"tooltip_component-arrow-86a47982bb","content":"tooltip_component-content-087e4ea7c6","multiline":"tooltip_component-multiline-6cf9c8be08","bottom_right":"tooltip_component-bottom_right-1d8dd71208","bottom_wide":"tooltip_component-bottom_wide-ee9483f221","bottom_left":"tooltip_component-bottom_left-9a3ebfbe4c","right_center":"tooltip_component-right_center-d56baa568f","top_left":"tooltip_component-top_left-e4e889b981","top_right":"tooltip_component-top_right-50ae83c6e8"};

/***/ }),

/***/ "./src/shared/index.tsx":
/*!******************************!*\
  !*** ./src/shared/index.tsx ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(/*! tslib */ "tslib");
var style_1 = __webpack_require__(/*! @cian/utils/lib/shared/style */ "@cian/utils/lib/shared/style");
var React = __webpack_require__(/*! react */ "react");
var react_dom_1 = __webpack_require__(/*! react-dom */ "react-dom");
var utils_1 = __webpack_require__(/*! ./utils */ "./src/shared/utils.ts");
var styles = __webpack_require__(/*! ./index.css */ "./src/shared/index.css");
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition[TooltipPosition["BOTTOM_LEFT"] = 0] = "BOTTOM_LEFT";
    TooltipPosition[TooltipPosition["RIGHT_CENTER"] = 1] = "RIGHT_CENTER";
    TooltipPosition[TooltipPosition["BOTTOM_WIDE"] = 2] = "BOTTOM_WIDE";
    TooltipPosition[TooltipPosition["BOTTOM_RIGHT"] = 3] = "BOTTOM_RIGHT";
    TooltipPosition[TooltipPosition["TOP_LEFT"] = 4] = "TOP_LEFT";
    TooltipPosition[TooltipPosition["TOP_RIGHT"] = 5] = "TOP_RIGHT";
})(TooltipPosition = exports.TooltipPosition || (exports.TooltipPosition = {}));
var Tooltip = /** @class */ (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            childrenHeight: 0,
            childrenWidth: 0,
            tooltipContentWidth: 0,
        };
        return _this;
    }
    Tooltip.prototype.focus = function () {
        if (this.element && this.element.focus) {
            this.element.focus();
        }
    };
    Tooltip.prototype.componentDidMount = function () {
        var _this = this;
        this.textSizeCalculator = utils_1.createTextSizeCalculator(styles['text_size_calculator']);
        this.recalculatePositionOnResize = utils_1.throttle(function () {
            _this.calculatePosition(_this.props);
        }, 50);
        this.calculatePosition(this.props);
        window.addEventListener('resize', this.recalculatePositionOnResize);
    };
    Tooltip.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.tooltipContent !== prevProps.tooltipContent) {
            this.calculatePosition(this.props);
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        if (this.textSizeCalculator && this.recalculatePositionOnResize) {
            this.textSizeCalculator.detach();
            window.removeEventListener('resize', this.recalculatePositionOnResize);
            this.textSizeCalculator = undefined;
            this.recalculatePositionOnResize = undefined;
        }
    };
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, propsChildren = _a.children, tooltipStyles = _a.tooltipStyles, tooltipContent = _a.tooltipContent, arrow = _a.arrow, multiline = _a.multiline, thin = _a.thin;
        var children = React.cloneElement(React.Children.only(propsChildren), { ref: function (element) { return _this.element = element; } });
        return (React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles(styles['wrapper'], tooltipStyles)),
            this.state.childrenWidth > 0 && !!tooltipContent &&
                React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles(styles['container'], this.getContainerStyle())),
                    React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles(styles['block'], thin && styles['thin'], arrow && styles['arrow'], this.getTooltipStyle())),
                        React.createElement("span", tslib_1.__assign({}, style_1.mergeStyles(styles['content'], multiline && styles['multiline'])), tooltipContent))),
            children));
    };
    Tooltip.prototype.getContainerStyle = function () {
        switch (this.props.position) {
            case TooltipPosition.RIGHT_CENTER:
                return [
                    styles['right_center'],
                    {
                        left: this.state.childrenWidth,
                        top: this.state.childrenHeight / 2,
                    },
                ];
            case TooltipPosition.BOTTOM_WIDE:
                return [
                    styles['bottom_wide'],
                    {
                        left: 0,
                        right: 0,
                        top: this.state.childrenHeight,
                    },
                ];
            case TooltipPosition.BOTTOM_RIGHT:
                return [
                    styles['bottom_right'],
                    {
                        right: 0,
                        top: this.state.childrenHeight,
                    },
                ];
            case TooltipPosition.TOP_LEFT:
                return [
                    styles['top_left'],
                    {
                        bottom: this.state.childrenHeight,
                        left: 0,
                    },
                ];
            case TooltipPosition.TOP_RIGHT:
                return [
                    styles['top_right'],
                    {
                        bottom: this.state.childrenHeight,
                        right: 0,
                    },
                ];
            default:
                return [
                    styles['bottom_left'],
                    {
                        top: this.state.childrenHeight,
                    },
                ];
        }
    };
    Tooltip.prototype.getTooltipStyle = function () {
        if (this.props.position === TooltipPosition.BOTTOM_WIDE) {
            return styles['wide'];
        }
        return {
            width: this.state.tooltipContentWidth,
        };
    };
    Tooltip.prototype.calculatePosition = function (props) {
        var children = react_dom_1.findDOMNode(this).children;
        var childrenRect = children[children.length - 1].getBoundingClientRect();
        this.setState({
            childrenHeight: childrenRect.height,
            childrenWidth: childrenRect.width,
            tooltipContentWidth: this.textSizeCalculator
                ? this.textSizeCalculator.calculate(props.tooltipContent)
                : this.state.tooltipContentWidth,
        });
    };
    Tooltip.defaultProps = {
        arrow: true,
        multiline: false,
        position: TooltipPosition.BOTTOM_LEFT,
        thin: false,
    };
    return Tooltip;
}(React.Component));
exports.Tooltip = Tooltip;


/***/ }),

/***/ "./src/shared/utils.ts":
/*!*****************************!*\
  !*** ./src/shared/utils.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function throttle(fn, threshhold) {
    if (threshhold === void 0) { threshhold = 250; }
    var last;
    var deferTimer;
    return function () {
        var now = Date.now();
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn();
            }, threshhold);
        }
        else {
            last = now;
            fn();
        }
    };
}
exports.throttle = throttle;
var sharedNode;
function getSharedNode() {
    if (!sharedNode) {
        sharedNode = window.document.createElement('div');
        sharedNode.style.position = 'fixed';
        sharedNode.style.top = '-1000px';
        sharedNode.style.visibility = 'hidden';
        sharedNode.style.width = 'auto';
        sharedNode.style.height = 'auto';
        sharedNode.style.whiteSpace = 'nowrap';
        sharedNode.style.zIndex = '-1';
        window.document.body.appendChild(sharedNode);
    }
    return sharedNode;
}
function createTextSizeCalculator(className) {
    var node = getSharedNode();
    return {
        calculate: function (text) {
            node.className = className;
            if (node.textContent !== text) {
                node.textContent = text;
            }
            return node.clientWidth + 1;
        },
        detach: function () { return undefined; },
    };
}
exports.createTextSizeCalculator = createTextSizeCalculator;


/***/ }),

/***/ "@cian/utils/lib/shared/style":
/*!***********************************************!*\
  !*** external "@cian/utils/lib/shared/style" ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@cian/utils/lib/shared/style");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ })

/******/ });
//# sourceMappingURL=frontend-tooltip-component.js.map